import { Role } from '@/constants/role.js'
const meta = { authorize: [Role.user] }

export default [
    {
        path: '/',
        meta,
        component: () => import('@pages/p-base'),
        children: [
            {
                path: '',
                name: 'user-main',
                meta,
                component: () => import('@organisms/o-user-main'),
            },
            {
                path: 'related',
                name: 'user-related',
                meta,
                component: () => import('@organisms/o-user-members'),
            },
            {
                path: 'profile',
                name: 'user-profile',
                meta,
                component: () => import('@organisms/o-user-profile'),
            },
        ],
    },
]
